export const STIX = "stix";
export const CONCEPT = "concept";
export const INSIGHT = "insight";